import React from 'react'

/**
 */
export const Context = React.createContext({})

/**
 */
export const Consumer = Context.Consumer
